export const stages = [
  {
    value: 'Grievance',
    label: 'Grievance',
  },
  {
    value: 'Negotiations',
    label: 'Negotiations',
  },
  {
    value: 'ACAS',
    label: 'ACAS',
  },
  {
    value: 'Tribunal',
    label: 'Tribunal',
  },
  {
    value: 'None',
    label: 'None of the above',
  },
];
